import { Box, Container as MuiContainer } from "@mui/material";
import { styled } from "@mui/material/styles";

const DESKTOP_BREAKPOINT = 1024;
const TABLET_BREAKPOINT = 640;

export const Root = styled("footer")(({ theme }) => ({
  width: "100%",
  backgroundColor: theme.palette.background.paper,
  borderTop: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.primary,
  WebkitFontSmoothing: "antialiased",
}));

export const Container = styled(MuiContainer)(({ theme }) => ({
  paddingTop: 56,
  paddingBottom: 40,
  [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
    paddingTop: 40,
    paddingBottom: 32,
  },
}));

export const TopGrid = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1.25fr 1.6fr 1.1fr 0.82fr 0.9fr",
  gap: 40,
  marginBottom: 28,
  [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
    gridTemplateColumns: "1fr 1fr",
    gap: "40px 32px",
  },
  [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
    gridTemplateColumns: "1fr",
    gap: 32,
  },
}));
